import { type HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

type Props = HTMLAttributes<HTMLDivElement> & {
  /** Tighter letter spacing for label-like contexts. Default is the title-style spacing. */
  tight?: boolean;
};

/**
 * Brand "eyebrow" text — small uppercase semibold label above titles or sections.
 *   <Eyebrow>Рабочее пространство</Eyebrow>
 *   <Eyebrow tight>Корзина · 3</Eyebrow>
 */
export function Eyebrow({ className, tight, ...rest }: Props) {
  return (
    <div
      className={cn(
        "text-[11px] font-display font-semibold uppercase text-ink-40",
        tight ? "tracking-[0.07em]" : "tracking-[0.16em]",
        className,
      )}
      {...rest}
    />
  );
}
